(() => {
  const eventName = 'jatka:contact_map_click';

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-jatka-map-action]');
    if (!link) return;

    const payload = {
      action: link.dataset.jatkaMapAction,
      destination: 'Jatka Butchery Wilanow',
      page_location: window.location.href
    };

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(eventName, payload);
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event: 'jatka_contact_map_click', ...payload });
    }
  });
})();
